import Cell from './cell.vue'
import Field from './field.vue'
import SmsField from './sms-field.vue'
import List from './list.vue'

Cell.install = Vue => {
  Vue.component(Cell.name, Cell)
}

Field.install = Vue => {
  Vue.component(Field.name, Field)
}

SmsField.install = Vue => {
  Vue.component(SmsField.name, SmsField)
}

List.install = Vue => {
  Vue.component(List.name, List)
}

export {Cell, Field, SmsField, List}



// WEBPACK FOOTER //
// ./src/components/cell/index.js